export default __webpack_public_path__ + "static/media/pipesEmbossingreduce.0eeb5b17.jpg";